module.exports = "pegasus/assets/blocks/header-5-theme5.png";